<template>
  <div class="container-list">
    <div class="search-line">
      <div class="left">
        <el-input v-model="queryParams.name" class="search-input" :placeholder="`装载用具`"></el-input>
        <!-- 查询 -->
        <el-button icon="el-icon-search" type="primary" size="mini" @click="search()">查询</el-button>
        <!-- 导入 -->
        <el-button icon="el-icon-upload2" type="primary" size="mini" @click="importList()">导入</el-button>
        <!-- 导出 -->
        <el-button type="primary" size="mini" @click="exportList()">导出</el-button>
        <!-- 新建 -->
        <el-button size="mini" icon="el-icon-plus" type="primary" @click="goNew()">新建</el-button>
      </div>
    </div>
    <div class="page-card">
      <table-header-editor :headers="tableHeaders" class="table-header-editor" />
      <el-tabs v-model="queryParams.group">
        <el-tab-pane v-for="(tab, tabindex) in sorts" :key="tabindex" :label="tab.name" :name="`${tab.value}`"></el-tab-pane>
      </el-tabs>
      <el-table
        :data="list"
        :header-cell-class-name="'table-header-cell'"
        @sort-change="sortChange"
        border
      >
        <el-table-column
          v-for="(item) in tableHeaders"
          :key="item.id"
          :type="item.type"
          :label="item.label"
          :prop="item.prop"
          :sortable="!!item.sortKey ? 'custom': false"
          :sort-by="item.sortKey"
          :width="item.width">
            <template slot-scope="scope">
              <span v-if="item.type ==='index'">{{scope.$index + 1}}</span>
              <span v-else>{{scope.row[item.prop]}}</span>
              <el-tooltip v-if="item.handle" effect="dark" :content="`编辑`" placement="top-start">
                <el-button class="p0 fontsize20" type="text" @click.prevent="goEdit(scope.row)"><i class="el-icon-edit-outline"></i></el-button>
              </el-tooltip>
              <el-tooltip v-if="item.handle" effect="dark" :content="`删除`" placement="top-start">
                <el-button class="p0 fontsize20" type="text" @click.prevent="goDelete(scope.row.id)"><i class="el-icon-delete"></i></el-button>
              </el-tooltip>
            </template>
        </el-table-column>
      </el-table>
      <pagination :queryParams="queryParams" :getList="getList" />
    </div>
    <ImportFile :link="'/template/basic/basket/'+`装载用具管理`+'.xlsx'" ref="importFile" @complete="getImport" />
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination.vue'
import TableHeaderEditor from '@/components/common/TableHeaderEditor.vue'
import { containerList, containerDelete, exportContainer, containerImport } from '@/api.js'
import { pageSize } from '@/utils/Config.js'
import ImportFile from '@/components/common/ImportFile.vue'
export default {
  name: 'ContainerList',
  components: {
    Pagination,
    TableHeaderEditor,
    ImportFile
  },
  data() {
    return {
      activeMode: 'card', // 列表样式：card, list
      queryParams: { // 请求参数
        name: '',
        group: '',
        pageIndex: 1,
        pageSize,
        _total: 0
      },
      sorts: [],
      tableHeaders: [],
      list: []
    }
  },
  watch: {
    'queryParams.group' (newValue) {
      if (newValue) {
        this.getList()
      }
    }
  },
  async mounted() {
    await this.getTypes()
    this.getList()
  },
  methods: {
   getTypes() {
      // 获取容器类型
      return this.$utils.getDict(304)
      .then((options) => {
        if ( options ) {
          this.sorts = options[304]
          this.sorts.unshift({
            value: '0',
            name: `全部`
          })
          this.queryParams.group = this.sorts[0].value
        }
      })
    },
    exportList() {
    // 导出list
      const { name, group } = this.queryParams

      this.$utils.exportFile(exportContainer, { name, group })
    },
    search() {
      this.queryParams.pageIndex = 1
      this.getList()
    },
    getList() {
      // 获取列表数据
      const url = containerList
      const {
        pageIndex,
        pageSize,
        name,
        group,
        orderBy,
        order
      } = this.queryParams
      const queryParams = {
        page: pageIndex,
        per_page: pageSize,
        name: name.trim(),
        group,
        order_column: orderBy,
        order
      }
      this.$request('get', url, queryParams)
      .then((res) => {
        if (res) {
          const prev = [
            {
              width: 60,
              label: '#',
              prop: '',
              type: 'index',
              checked: true
            }
          ]
          const last = [
            {
              width: 'auto',
              label: `操作`,
              prop: '',
              checked: true,
              handle: true
            }
          ]

          this.tableHeaders = this.tableHeaders.length > 0 ? this.tableHeaders : this.$utils.generateColumns(res.columns, prev, last)
          this.list = res.data
          this.queryParams._total = res.total
        }
      })
    },
    sortChange(item) {
      // 排序方法
      const { column, order } = item
      const orderString = order ? order === 'ascending' ? 'asc' : 'desc' : undefined
      const orderBy = order ? column.sortBy : undefined

      this.queryParams.order = orderString
      this.queryParams.orderBy = orderBy
      this.getList()
    },
    goEdit(item) {
      // 调转编辑页
      this.$router.push(`/basic/container/edit/${item.id || 0}`)
    },
    goNew() {
      // 跳转新建
      this.$router.push(`/basic/container/edit/0`)
    },
    goDelete(id) {
      // 确认删除
      this.$confirm(`确认删除吗?`,{
        type: 'warning',
        // 确定
        confirmButtonText: `确定`,
        // 取消
        cancelButtonText: `取消`,
      })
      .then(() => {
        const url = containerDelete.replace('{id}', id)
        this.$request('post', url, {})
        .then((res) => {
          if (res) {
            this.$message.success(`删除成功`)
            this.getList()
          }
        })
      })
      .catch(() => {
        console.log('取消删除')
      })
    },
    importList() {
      // 开始导入
      this.$refs.importFile.show()
    },
    getImport(file) {
      // 接收导入文件信息
      const info = {
        file_id: file.fileId
      }
      this.$request('post', containerImport, info)
      .then((res) => {
        if (res) {
          this.$message.success(`导入成功`)
          this.getList()
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/css/common.scss';
  .container-list {
    .page-card {
      position: relative;
      .table-header-editor {
        position: absolute;
        right: 10px;
        z-index: 5;
      }
    }
  }
</style>